import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the communications state domain
 */

const selectCommunicationsMobileDomain = state =>
  state.communicationsMobile || initialState;

/**
 * Other specific selectors
 */

const makeSelectItemsList = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListAllData = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.allData,
  );

const makeSelectItemsListCurrentPage = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.currentPage,
  );
  
const makeSelectItemsListTotalAmount = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.totalAmount,
  );
  
const makeSelectItemsListFilteringParams = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.params,
  );

const makeSelectChildId = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.childId,
  );

const makeSelectItemsListNoMore = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.noMore,
  );

const selectCommunicationsLoading = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.loading,
  );

const selectCommunicationsError = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.error,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate.firstRender,
  );


/**
 * Default selector used by Communications
 */
const makeSelectCommunications = () =>
  createSelector(
    selectCommunicationsMobileDomain,
    substate => substate,
  );
export default makeSelectCommunications;
export {
  makeSelectFirstRender,
  makeSelectChildId,
  selectCommunicationsMobileDomain,
  // list
  selectCommunicationsLoading,
  selectCommunicationsError,
  makeSelectItemsListAllData,
  makeSelectItemsList,
  makeSelectItemsListFilteringParams,
  makeSelectItemsListNoMore,
  makeSelectItemsListTotalAmount,
  makeSelectItemsListCurrentPage,
};
